/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Outlook_Read_SuccessInputs */

const es_tools_outlook_read_success = /** @type {(inputs: Tools_Outlook_Read_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correo de Outlook leído`)
};

const en_tools_outlook_read_success = /** @type {(inputs: Tools_Outlook_Read_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outlook message read`)
};

/**
* | output |
* | --- |
* | "Outlook message read" |
*
* @param {Tools_Outlook_Read_SuccessInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_outlook_read_success = /** @type {((inputs?: Tools_Outlook_Read_SuccessInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Outlook_Read_SuccessInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_outlook_read_success(inputs)
	return en_tools_outlook_read_success(inputs)
});
export { tools_outlook_read_success as "tools.outlook.read_success" }